import {
  Box,
  Grid,
  AppBar,
  Hidden,
  SvgIcon,
  Toolbar,
  IconButton,
  Typography,
  Menu,
  MenuItem,
} from "@mui/material";
import clsx from "clsx";
import { Menu as MenuIcon, LogOut as LogOutIcon } from "react-feather";
import logo from "../../../assets/images/AcrossLogo.png";
import { URL_CONFIG } from "../../../config/urlConfig";
import { useTopBarData } from "./TopBarData";
import "./index.scss";

const TopBar = ({ className, onMobileNavOpen, ...rest }) => {
  const {
    navigate,
    userRole,
    anchorEl,
    handleUserClick,
    handleUserClose,
    onLogout,
  } = useTopBarData();

  return (
    <AppBar
      elevation={0}
      color="inherit"
      position="fixed"
      className={clsx("top-bar", className)}
      {...rest}
    >
      <Toolbar className="top-bar__toolbar">
        <Hidden lgUp>
          <IconButton onClick={onMobileNavOpen} className="top-bar__menu-icon">
            <SvgIcon>
              <MenuIcon className="top-bar__menu-icon-svg" />
            </SvgIcon>
          </IconButton>
        </Hidden>

        <Box className="top-bar__main">
          <Grid container alignItems="center">
            <Grid item lg={3} md={3} sm={4} xs={6}>
              {URL_CONFIG.SHOW_SIDEBAR ? null : (
                <Box className="top-bar__logo-box">
                  <IconButton
                    className="top-bar__logo-button"
                    onClick={() => navigate("/admin-dashboard")}
                  >
                    <img alt="Logo" src={logo} className="top-bar__logo-img" />
                  </IconButton>
                </Box>
              )}
            </Grid>

            <Grid
              item
              lg={9}
              md={9}
              sm={8}
              xs={6}
              className="top-bar__profile-grid"
            >
              <Box className="top-bar__profile-container">
                <Hidden mdDown>
                  <Box className="top-bar__user-info">
                    <Typography className="top-bar__greeting">
                      Hello, {userRole ? userRole : "Admin"}
                    </Typography>
                  </Box>
                </Hidden>

                {URL_CONFIG.SHOW_SIDEBAR === false ? (
                  <Box className="top-bar__avatar-container">
                    <IconButton
                      className="top-bar__avatar-button"
                      onClick={handleUserClick}
                    >
                      <img
                        alt="Profile"
                        height={40}
                        src={require("../../../assets/images/Profile.png")}
                      />
                    </IconButton>
                    <Menu
                      id="user-menu"
                      anchorEl={anchorEl}
                      keepMounted
                      open={Boolean(anchorEl)}
                      onClose={handleUserClose}
                      className="top-bar__menu"
                    >
                      <MenuItem
                        onClick={() => {
                          onLogout();
                        }}
                        className="top-bar__logout-item"
                      >
                        <SvgIcon
                          component={LogOutIcon}
                          className="top-bar__logout-icon"
                        />
                        Logout
                      </MenuItem>
                    </Menu>
                  </Box>
                ) : (
                  <IconButton className="top-bar__avatar-button">
                    <img
                      alt="Profile"
                      height={40}
                      src={require("../../../assets/images/Profile.png")}
                    />
                  </IconButton>
                )}
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default TopBar;
